export default "__VITE_ASSET__a72bc054__"